import clsx from 'clsx'
import {HTMLProps} from 'react'

/**
 * Available list density variants.
 */
export type DensityVariant = 'default' | 'dense' | 'light'

const densityMapping: Record<DensityVariant, string> = {
  default: 'gap-4',
  dense: 'gap-2',
  light: 'gap-8',
}

export interface ListProps extends HTMLProps<HTMLUListElement> {
  /**
   * Density of list items.
   *
   * @default 'default'
   */
  density?: DensityVariant
}

export function List({
  className,
  children,
  density = 'default',
  ...props
}: ListProps) {
  return (
    <ul className={clsx('grid', densityMapping[density], className)} {...props}>
      {children}
    </ul>
  )
}

export default List
